var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.isLogin)?_c('el-container',[_c('el-main',[_c('headerTop'),_c('div',{staticClass:"main-container"},[_c('router-view')],1)],1)],1):_vm._e(),(_vm.isLogin)?_c('el-container',[_c('router-view')],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }